<template>
  <router-link
    :to="to"
    class="el-button"
    :class="[
      type ? 'el-button--' + type : '',
      buttonSize ? 'el-button--' + buttonSize : '',
      {
        'is-plain': plain,
        'is-round': round,
        'is-circle': circle
      }
    ]"
  >
    <i
      v-if="icon"
      :class="icon"
    />
    <span v-if="$slots.default">
      <slot />
    </span>
  </router-link>
</template>

<script>
/**
 * Based on:
 * https://github.com/ElemeFE/element/blob/dev/packages/button/src/button.vue
 */
export default {
  name: 'CButtonLink',

  props: {
    to: {
      type: [Object, String],
      required: true
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String
    },
    icon: {
      type: String
    },
    plain: {
      type: Boolean
    },
    round: {
      type: Boolean
    },
    circle: {
      type: Boolean
    }
  },

  computed: {
    buttonSize () {
      return this.size || (this.$ELEMENT || {}).size
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button {
  text-decoration: none;
}
</style>
